import { useRef } from "react";

import type { PriceCategoryListItemDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import {
  PriceCategoryForm,
  type PriceCategoryFormHandle,
} from "PriceCategories/Forms/PriceCategoryForm";
import type { PriceCategoryFormData } from "PriceCategories/Forms/priceCategoryFormSchema";
import { BlModal } from "Shared/Dialogs/BlModal";

interface EditPriceCategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: PriceCategoryFormData) => void;
  priceCategory: PriceCategoryListItemDto;
  serverError?: Error | null;
}

export const EditPriceCategoryModal = ({
  isOpen,
  onClose,
  onConfirm,
  priceCategory,
  serverError,
}: EditPriceCategoryModalProps): React.ReactNode => {
  const { t } = useResource();
  const formRef = useRef<PriceCategoryFormHandle | null>(null);

  const onSubmit = (data: PriceCategoryFormData) => {
    onConfirm({ ...data, commissionRate: data.commissionRate / 100 });
  };

  const handleClose = () => {
    formRef.current?.reset();
    onClose();
  };

  return (
    <BlModal
      isOpen={isOpen}
      title={t(Resources.PriceCategories.EditModal.Title)}
      onCancel={handleClose}
      onConfirm={() => formRef.current?.submit(onSubmit)()}
      cancelButtonText={t(Resources.Common.Cancel)}
      confirmButtonText={t(Resources.PriceCategories.EditModal.Save)}
    >
      <PriceCategoryForm
        priceCategory={priceCategory}
        formRef={formRef}
        serverError={serverError}
      />
    </BlModal>
  );
};
